import React, { Component } from 'react';
import Header from './header';
import Footer from './footer';


class PrivacyPolicy extends Component {
    state = {  } 
    render() { 
        return (
            <div className='d-flex flex-column min-vh-100 '>
                <Header onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
                <div className='pb-2 px-5 flex-grow-1'>
                    <div className={this.props.onEngLanguage()}>
                        <br />
                        <h2>Privacy policy</h2>
                        <br />
                    
                        <div>
                            We are committed to protecting your privacy.
                        </div>
                        <div>
                            We will only use the information that we collect about you lawfully in accordance with the Law of Georgia on
                                Personal Data Protection.
                        </div>
                        <div>
                            We do not share your personal information with third parties.
                        </div>
                        <div>
                            The type of information we will collect about you includes: Your name,and Email address
                        </div>
                        <div>   
                            We will never collect sensitive information about you without your explicit consent.
                        </div>
                    </div>
                    <div className={this.props.onGeoLanguage()}>
                        <br />
                        <h3>კონფიდენციალურობის პოლიტიკა</h3>
                        <br />
                    
                        <div>
                            ჩვენ ვაგროვებთ თქვენს მიერ ნებაყოფლობით მოწოდებულ მონაცემებს „პერსონალური მონაცემების დაცვის შესახებ“ საქართველოს კანონის შესაბამისად. 
                        </div>
                        <div>
                            თქვენს შესახებ შეგროვებული ინფორმაცია მოიცავს შემდეგ მონაცემებს: სახელი, გვარი, ელექტრონული მისამართი, ტელეფონის ნომერი და სამუშაო ადგილი. 
                        </div>
                        <div>
                            ჩვენ არ ვინახავთ თქვენს შესახებ ინფორმაციას თქვენი თანხმობის გარეშე.
                        </div>
                        <div>
                            ჩვენ ვიცავთ თქვენს მიერ მოწოდებული მონაცემების კონფიდენციალურობას.
                        </div>
                        <div>
                            ჩვენ არ ვუზიარებთ თქვენს პერსონალურ ინფორმაციას მესამე პირებს.
                        </div>
                        <div>   
                            ჩვენ ვიყენებთ თქვენს მიერ მოწოდებულ ინფორმაციას მარკეტინგული მიზნებისათვის, რაც გულისხმობს ჩვენი მომსახურეობის და/ან სიახლეების შესახებ თქვენს ინფორმირებისათვის.  
                        </div>
                    </div>
                </div>

                <Footer
                    onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
            </div>
        );
    }
}
 
export default PrivacyPolicy;